import ImageWMS from 'ol/source/ImageWMS';
import {Image as ImageLayer} from 'ol/layer';
import KML from 'ol/format/KML';
import Map from 'ol/Map';
import VectorSource from 'ol/source/Vector';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import Geolocation from 'ol/Geolocation';
import Feature from 'ol/Feature';
import View from 'ol/View';
import {getVectorContext} from 'ol/render';
import {unByKey} from 'ol/Observable';
import {easeOut} from 'ol/easing';
import Point from 'ol/geom/Point';
import {
  Circle as CircleStyle,
  Fill,
  RegularShape,
  Stroke,
  Style,
  Text,
} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';
import {Cluster, Stamen} from 'ol/source';
import {createEmpty, extend, getHeight, getWidth} from 'ol/extent';
import {
  Select, 
} from 'ol/interaction';
import {
  defaults as defaultInteractions,
} from 'ol/interaction';
import {OverviewMap, defaults as defaultControls} from 'ol/control';

const windWMS = new ImageWMS({
  url: 'https://api.meteomatics.com/wms',
  params: {'LAYERS': 'wind_power_turbine_enercon_e101_3000_hub_height_110m:MW',
  'access_token':'eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJ2IjoxLCJ1c2VyIjoiYnVyZ2VubGFuZGVuZXJnaWVhZ19ob3J3YXRoIiwiaXNzIjoibG9naW4ubWV0ZW9tYXRpY3MuY29tIiwiZXhwIjoxNjcyNjY1Njc5LCJzdWIiOiJhY2Nlc3MifQ.xuC6xgfWqycNAmpUqwsYbr-KOXSD0VR9rT0Gv288q_kK1q9nYJk0eIAY9jHtjeBofGGbm_dR8Eo7fom17sQLPw',
  'token_type':'bearer',
  'STYLE':'JET',
  'CRS':'EPSG:3857',
  'FORMAT':'image/png'},
  ratio: 1,
  serverType: 'geoserver',
});

const windLayer = new ImageLayer({
    extent: [1777049.2920951599, 5913627.296863229, 1934148.9095180128, 6135245.094870726],
    source: windWMS,
  })

const windkraftanlagenFill = new Fill({
  color: 'rgba(255, 83, 17, 0.8)',
});
const windkraftanlagenStroke = new Stroke({
  color: 'rgba(255, 204, 0, 0.2)',
  width: 1,
});
const textFill = new Fill({
  color: '#fff',
});
const textStroke = new Stroke({
  color: 'rgba(0, 0, 0, 0.6)',
  width: 3,
});
const invisibleFill = new Fill({
  color: 'rgba(255, 255, 255, 0.01)',
});

function createWindkraftanlagenStyle(feature) {
  const name = feature.get('G3E_FID');
  const magnitude = 5.4;
  const radius = 5 + 20 * (magnitude - 5);

  return new Style({
    geometry: feature.getGeometry(),
    image: new RegularShape({
      radius1: radius,
      radius2: 1,
      points: 3,
      angle: Math.PI,
      fill: windkraftanlagenFill,
      stroke: windkraftanlagenStroke,
    }),
  });
}

let maxFeatureCount;
const calculateClusterInfo = function (resolution) {
  maxFeatureCount = 0;
  const features = vector.getSource().getFeatures();
  let feature, radius;
  for (let i = features.length - 1; i >= 0; --i) {
    feature = features[i];
    const originalFeatures = feature.get('features');
    const extent = createEmpty();
    let j, jj;
    for (j = 0, jj = originalFeatures.length; j < jj; ++j) {
      extend(extent, originalFeatures[j].getGeometry().getExtent());
    }
    maxFeatureCount = Math.max(maxFeatureCount, jj);
    radius = (0.25 * (getWidth(extent) + getHeight(extent))) / resolution;
    feature.set('radius', radius);
  }
};

let currentResolution;
function styleFunction(feature, resolution) {
  if (resolution != currentResolution) {
    calculateClusterInfo(resolution);
    currentResolution = resolution;
  }
  let style;
  const size = feature.get('features').length;
  if (size > 1) {
    style = new Style({
      image: new RegularShape({
        radius1: 30,
        fill: new Fill({
          color: [255, 83, 17, Math.min(0.8, 0.4 + size / maxFeatureCount)],
        }),
		radius2: 5,
      points: 3,
      angle: Math.PI,
      }),
      text: new Text({
        text: size.toString(),
        fill: textFill,
        stroke: textStroke,
      }),
    });
  } else {
    const originalFeature = feature.get('features')[0];
    style = createWindkraftanlagenStyle(originalFeature);
  }
  return style;
}

function selectStyleFunction(feature) {
  const styles = [
    new Style({
      image: new CircleStyle({
        radius: feature.get('radius'),
        fill: invisibleFill,
      }),
    }),
  ];
  const originalFeatures = feature.get('features');
  let originalFeature;
  for (let i = originalFeatures.length - 1; i >= 0; --i) {
    originalFeature = originalFeatures[i];
    styles.push(createWindkraftanlagenStyle(originalFeature));
  }
  return styles;
}

const vector = new VectorLayer({
  source: new Cluster({
    distance: 40,
    source: new VectorSource({
      url: 'data/windkraftanlagen.kml',
      format: new KML({
        extractStyles: false,
      }),
    }),
  }),
  style: styleFunction,
});

const raster = new TileLayer({
  source: new Stamen({
    layer: 'toner',
  }),
});
	
const tileLayer = new TileLayer({
  source: new OSM(),
  opacity: 0.6
});	

const overviewMapControl = new OverviewMap({
  // see in overviewmap-custom.html to see the custom CSS used
  className: 'ol-overviewmap ol-custom-overviewmap',
  layers: [
    new TileLayer({
  source: new OSM(),
})
  ],
  collapseLabel: '\u00BB',
  label: '\u00AB',
  collapsed: true,
});

const view = new View({
    center: [1866280, 6073889],
    zoom: 9,
  });

const geolocation = new Geolocation({  
  projection: view.getProjection()
});



const positionFeature = new Feature();
positionFeature.setStyle(
  new Style({
    image: new CircleStyle({
      radius: 6,
      fill: new Fill({
        color: '#ffcc00',
      }),
      stroke: new Stroke({
        color: '#000000',
        width: 2,
      }),
    }),
  })
);

const duration = 5000;
function flash(feature) {
  const start = Date.now();
  const flashGeom = feature.getGeometry().clone();
  const listenerKey = tileLayer.on('postrender', animate);

  function animate(event) {
    const frameState = event.frameState;
    const elapsed = frameState.time - start;
    if (elapsed >= duration) {
      unByKey(listenerKey);
      return;
    }
    const vectorContext = getVectorContext(event);
    const elapsedRatio = elapsed / duration;
    // radius will be 5 at start and 30 at end.
    const radius = easeOut(elapsedRatio) * 25 + 5;
    const opacity = easeOut(1 - elapsedRatio);

    const style = new Style({
      image: new CircleStyle({
        radius: radius,
        stroke: new Stroke({
          color: 'rgba(0, 0, 0, ' + opacity + ')',
          width: 0.25 + opacity,
        }),
      }),
    });

    vectorContext.setStyle(style);
    vectorContext.drawGeometry(flashGeom);
	 map.render();
  }
}



geolocation.on('change', function (evt) {
  const coordinates = geolocation.getPosition();
  positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
  flash(positionFeature);
});

geolocation.setTracking(true);




const vectorLoc = new VectorLayer({  
  source: new VectorSource({
    features: [positionFeature]
  }),
});

const map = new Map({
  controls: defaultControls().extend([overviewMapControl]),
  layers: [
    windLayer, tileLayer, vector, vectorLoc
  ],
  interactions: defaultInteractions().extend([
    new Select({
      condition: function (evt) {
        return evt.type == 'pointermove' || evt.type == 'singleclick';
      },
      style: selectStyleFunction,
    }),
  ]),
  target: 'map',
  view: view,
});
